<template>
  <div class="document-create-folder-dialog">
    <vs-prompt
      @accept="createFolder"
      @cancel="cancel"
      @close="close"
      :color="AISEA_COLOR.BLUE"
      :active.sync="showDialog"
      :title="title"
      :accept-text="acceptText"
      :cancel-text="cancelText"
      :is-valid="validateForm"
    >
      <div>
        <span>フォルダ名</span>
        <vs-input
          v-model="folderName"
          class="w-full"
          v-validate="'required|max:255'"
          :name="fieldName"
          @input="validateFolderName"
          data-vv-as="フォルダ名"
        />
        <span class="text-danger text-sm" v-show="errors.any()">{{
          errors.first(fieldName)
        }}</span>
        <br />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import _ from "lodash";
import { createNamespacedHelpers } from "vuex";
import { ColorMixin, DocumentMixin } from "@/mixins";

const {
  mapActions: mapActionsOfEnterpriseDocumentManager,
} = createNamespacedHelpers("enterpriseDocumentManager");

export default {
  components: {},
  mixins: [ColorMixin, DocumentMixin],
  props: {
    isProcessingDialog: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      folderName: null,
      error: { message: null },
      showDialog: false,
      title: "新規フォルダ作成",
      acceptText: "作成",
      cancelText: "キャンセル",
      path: null,
      fieldName: "create-name",
    };
  },
  computed: {
    validateForm () {
      return (
        this.required() &&
        !this.errors.any()
      );
    }
  },
  methods: {
    ...mapActionsOfEnterpriseDocumentManager(["addFolder"]),
    show (path) {
      this.folderName = null;
      this.showDialog = true;
      this.path = path;
    },

    validateFolderName () {
      if (this.folderName.length === 0) {
        this.$validator.errors.remove(this.fieldName);
        return;
      }
      this._validateFolderName(this);
    },

    _validateFolderName: _.debounce(async (self) => {
      const payload = {
        name: self.folderName,
        field: self.fieldName,
      }
      await self.validateExistsFolderName(payload)
      self.validateSlash(payload)

    }, 500),

    required () {
      return this.folderName !== null
    },

    async createFolder () {
      this.$vs.loading();
      try {
        const payload = {
          path: `${this.path}${this.folderName}/`,
          isProcessingDialog: this.isProcessingDialog
        };
        await this.addFolder(payload);
        this.$vs.loading.close();
        this.$vs.notify({
          title:
            "フォルダを作成しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        this.close();
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "フォルダの作成に失敗しました",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
        console.error(e)
        this.close();
      }
    },

    close () {
      this.cleanUp();
    },

    cancel () {
      this.cleanUp();
    },

    cleanUp () {
      this.$validator.errors.remove(this.fieldName)
      this.showDialog = false;
    }
  }
};
</script>

<style lang="scss"></style>
